import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../../order/models/orderModel';
import RotateBarcodeOrder from '../../../pages/order/actions/rotateBarcode';
import RotateBarcodePostAction from '../post-action/rotateBarcodePostAction';
import { TICKET_SWAP_DISTRIBUTOR } from '../../../models/distributor';

export default class RotateBarcode extends AttendeeAction {
    static NAME = 'rotate_barcode';
    static POST_ACTION_COMPONENT = RotateBarcodePostAction;
    static ASYNCHRONOUS_LIMIT_MIN = 50;

    static condition(attendee) {
        return (
            ['valid', 'reservation'].includes(attendee.order.status) &&
            attendee.order.origin !== 'weez_invitation' &&
            !attendee.removed &&
            attendee.order.distributor !== TICKET_SWAP_DISTRIBUTOR
        );
    }

    static is_attendee_valid({ attendee }) {
        return !attendee.removed;
    }

    static is_available({ event }) {
        return !['over', 'closed'].includes(event.status) && !event.removed;
    }

    run({ orders = null, attendees = null }) {
        if (orders) {
            const to_rotate = orders.filter(o => RotateBarcodeOrder.condition(o));
            this.filtered_orders = to_rotate;
            this.mode = RotateBarcodeOrder.TYPE;
            return Promise.resolve(true);
        }
        this.filtered_attendees = attendees || this.filtered_items;
        this.mode = this.constructor.TYPE;
        return Promise.resolve(true);
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }

    get post_action() {
        return true;
    }

    get withToastRun() {
        return false;
    }

    runPostAction({ items, mode, send_mail, to_reservation }) {
        if (mode === 'orders') {
            return Order.perform_action(RotateBarcodeOrder.NAME, items, { organization: this.organization, event: this.event, send_mail, to_reservation });
        }

        return Attendee.perform_action(this.constructor.NAME, items, { organization: this.organization, event: this.event, send_mail, to_reservation }, this.isAsync(items));
    }
}
